var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"schulte-wrap"},[_c('div',{staticClass:"head"},[_c('div',{staticClass:"tabs"},_vm._l((_vm.modes),function(m){return _c('div',{key:m.key,class:{'tab': true, 'active': _vm.mode === m.key},on:{"click":function($event){return _vm.switchMode(m.key)}}},[_vm._v(_vm._s(m.name))])}),0)]),_c(_vm.currentComp,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }